import { requestForVerificationCode } from "@/libs/apis/onboarding/mfa";
import useCurrentUserEmail from "@/src/services/auth/useCurrentUserEmail";
import { isUndefined } from "lodash";
import { useEffect, useState } from "react";
import {
  VerificationMethod,
  SecureNumberState,
} from "../contexts/MFAContextProvider/types";
import { useCurrentUser } from "@/libs/apis/onboarding/useUser";

const useMakeInitialVerificationCodeRequest = (
  initialVerificationMethod: VerificationMethod,
  mfaState: SecureNumberState,
  enabled: boolean, // determines whether to trigger initial call or not, this is primarily used for modal which mounts but is not visible
) => {
  // using a local version of mfaId so that this hook is not tied to the entire provider
  const [mfaId, setMfaId] = useState<string | undefined>(undefined);
  // we only want the initial verification request to go out on first load,
  // but we also want to be able to reset it
  const [firstLoad, setFirstLoad] = useState<boolean>(true);
  const currentUserEmail = useCurrentUserEmail();

  const { currentUser } = useCurrentUser();
  // we now use user's IDN profile phone number
  // (no longer collected during onboarding)
  const userHasNumber = !!currentUser?.contact?.sms?.verifiedNumber;

  useEffect(() => {
    if (
      mfaState === SecureNumberState.VERIFICATION &&
      userHasNumber &&
      enabled &&
      !isUndefined(currentUserEmail) &&
      firstLoad
    ) {
      requestForVerificationCode(initialVerificationMethod).then((mfaId) =>
        setMfaId(mfaId),
      );
      setFirstLoad(false);
    }
  }, [
    firstLoad,
    initialVerificationMethod,
    userHasNumber,
    enabled,
    currentUserEmail,
    mfaState,
  ]);

  return { firstLoad, setFirstLoad, initialMfaId: mfaId };
};

export default useMakeInitialVerificationCodeRequest;
